<div >
    <div *ngIf="debug" class="debug-div" >
        <div class="debug-header" (click)="expanded = !expanded" style="cursor:pointer">
            <span *ngIf="expanded">
                Debug Center
            </span>
            <span *ngIf="!expanded">
                DC
            </span>
            <i class="fa-solid fa-plus"></i>
        </div>
        <div *ngIf="expanded">
            <button class="btn btn-danger" (click)="stopTranslating()">Stop Translating</button>
            <button class="btn btn-primary" (click)="startTranslating()">Start Translating</button><br>

            <button class="btn btn-danger" (click)="oldCheckoutOverride()">Old Checkout Override</button>
            <button class="btn btn-primary" (click)="removeOldCheckoutOverride()">Remove override</button><br>
            Old Checkout override: <span style="color:green">{{usingOldCheckoutOverride}}</span><br>

            <button class="btn btn-danger" (click)="disableFormValidation()">Disable form validation</button>
            <button class="btn btn-primary" (click)="enableFormValidation()">Enable form validation</button><br>
            Form validation disabled: <span style="color:green">{{isFormValidationDisabled}}</span><br><br>

            <div *ngIf="showKcpInformation">
                KCP Debug Status:
                <select class="form-control"
                        [value]="kcpReconciliationSuffix"
                        (change)="kcpReconciliationSuffixChanged($event)">
                    <option value="">STANDARD</option>
                    <option value="0">PENDING</option>
                    <option value="1">DECLINED</option>
                    <option value="2">COMPLETED</option>
                    <option value="4">TRADE_NOT_EXIST</option>
                    <option value="5">CANCELLED</option>
                </select>
            </div>
            <br/>

            <div>
                Show Customer <span class="fa-solid fa-plus" (click)="showCustomerDebug = !showCustomerDebug" style="cursor:pointer"></span>
                <div *ngIf="showCustomerDebug">
                    <pre>{{user | json}}</pre>
                </div>
            </div>
            <div>
                Show Cart <span class="fa-solid fa-plus" (click)="showCartDebug = !showCartDebug" style="cursor:pointer"></span>
                <div *ngIf="showCartDebug">
                    <pre>{{cart | json}}</pre>
                </div>
            </div>
            <div>
                Show Ao Cart <span class="fa-solid fa-plus" (click)="showAoDebug = !showAoDebug" style="cursor:pointer"></span>
                <div *ngIf="showAoDebug">
                    <pre>{{autoOrders | json}}</pre>
                </div>
            </div>
            <div>
                Show Share List <span class="fa-solid fa-plus" (click)="showShareList = !showShareList" style="cursor:pointer"></span>
                <div *ngIf="showShareList">
                    <pre>{{shareLists | json}}</pre>
                </div>
            </div>
            <div>Usana Locale: {{usanaLocale}}</div>
            <div>Teas Locale: {{teasLocale}}</div>
            <div>UX Library: {{uxLibraryVersion}}</div>
        </div>
    </div>
</div>
